import React, { useEffect } from 'react';
import { creating } from '../../../constants/copyright';
import { safeHTML } from '../../../utils/safeHTML';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import Form from '../../baseComponents/gui/form/Form';
import Input from '../../baseComponents/gui/input/Input';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import useStateControls from '../../../hooks/useStateControls';
import Room from '../../features/room/Room';
import { randomChoice } from '../../../utils/helpers/helpers';
import { useUser } from '../../../redux/reducer/user';
import { useRequests } from '../../../redux/reducer/requests';
import { GTMContinueName } from '../../../constants/analytics/GTM';
import { useTranslation } from '../../../translations';

const CreatingPerson = React.forwardRef(function CreatingPerson({ callbacks }, ref) {
  const {
    authData: { isWeb },
  } = useRequests();
  const { profile: { username } = {} } = useUser();
  const { title, form, button, generateButton } = creating;
  const { setState } = useStateControls();
  const { t } = useTranslation();
  const inputs = form(t)?.filter((item) => item.input) ?? [];

  const onGenerate = (event) => {
    event && event.preventDefault();
    callbacks.generateName();
  };

  const onClick = (e) => {
    onGenerate(e);
    callbacks.addAnimations([{ state: 'creating', animation: randomChoice('wink', 'happy') }]);
  };

  const onSubmit = () => {
    setState('main');
    GTMContinueName();
  };

  useEffect(() => {
    onGenerate();
  }, []);

  return (
    <section className={'creating-person'} ref={ref}>
      <div className='creating-person__content'>
        <h2 className={`creating-person__title ${isWeb ? '' : 'app_margin'}`}>{safeHTML(t(title))}</h2>
        <div className='creating-person__room'>
          <Room callbacks={callbacks} />
        </div>
        <Form className='creating-person__form'>
          {inputs?.map(({ input }, index) => {
            return (
              <Input
                value={username}
                key={`input-${index}`}
                {...input}
                placeholder={t(input.placeholder)}
                Wrapper={(Input, props, keyStr) => (
                  <div className={'creating-person__form-item'} key={keyStr}>
                    {Input}
                  </div>
                )}
              >
                <div className={'creating-person__form-item-text'}>
                  <SwitchTransition>
                    <CSSTransition key={username} timeout={500} classNames={'creating-person__form-value'}>
                      {username.length ? <div className={'creating-person__form-value'}>{username}</div> : <div />}
                    </CSSTransition>
                  </SwitchTransition>
                </div>
              </Input>
            );
          })}
          <CustomButton
            onClick={onClick}
            className={'custom-button_generate custom-button_gray custom-button creating-person__generate'}
            text={generateButton.text}
            icon={'rotate'}
          />
          <CustomButton
            type='submit'
            onClick={onSubmit}
            className={'creating-person__button custom-button_show-anim'}
            text={button.text}
          />
        </Form>
      </div>
    </section>
  );
});
export default CreatingPerson;
CreatingPerson.propTypes = {};
